import { render, staticRenderFns } from "./header3.vue?vue&type=template&id=c44a997a&scoped=true"
import script from "./header3.vue?vue&type=script&lang=js"
export * from "./header3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44a997a",
  null
  
)

export default component.exports